import React, { useState } from "react";
import "./aboutus.css";
import Footernav from './Component/footernav'
function AboutUs() {
  const [activeTab, setActiveTab] = useState("company");

  const contentData = {
    company:
      "Welcome to your next great adventure. We are a Kathmandu-based travel team dedicated to showing you the real, unfiltered beauty of Nepal. Whether your dream is to stand face-to-face with the world’s highest peaks, walk through ancient heritage sites, or find quiet moments in hidden valleys, we handle all the heavy lifting so you can focus on the journey. We specialize in crafting seamless Nepal tour packages, mapping out unforgettable Himalayan trekking routes, and connecting you with licensed, expert local guides who tell the stories you won't find in guidebooks. No generic itineraries, no rigid tourist traps—just honest hospitality, deep local expertise, and a journey tailored to your pace. Let’s explore Nepal together.",
    vision:
      "Our vision is to become the most trusted travel brand globally by combining innovation, technology, and personalized customer experiences.",
    mission:
      "Our mission is to simplify travel for everyone by providing reliable services, transparent pricing, and 24/7 customer support.",
  };
  return (
    <main>
      <div className="about-us-box">
        <h1 className="i-am-under">About Us</h1>
      </div>
      <div className="out-sec">
      <div className="hill-section">
      {/* LEFT IMAGE */}
      <div className="hill-left">
        <img
          src="/img/company/off.jpg"
          alt="company"
          className="hill-image"
        />
      </div>

      {/* RIGHT CONTENT */}
      <div className="hill-right">
        <h2 className="hill-heading">Company</h2>
        <h2 className="hill-heading">Mission</h2>
         <h2 className="hill-heading">Vision</h2>
        {/* NAV */}
        <div className="hill-nav">
          <div
            className={`hill-nav-item ${
              activeTab === "company" ? "hill-active" : ""
            }`}
            onClick={() => setActiveTab("company")}
          >
            Company
          </div>

          <div
            className={`hill-nav-item ${
              activeTab === "vision" ? "hill-active" : ""
            }`}
            onClick={() => setActiveTab("vision")}
          >
            Vision
          </div>

          <div
            className={`hill-nav-item ${
              activeTab === "mission" ? "hill-active" : ""
            }`}
            onClick={() => setActiveTab("mission")}
          >
            Mission
          </div>
        </div>

        {/* CONTENT */}
        <div className="hill-content">
          <p className="hill-text">{contentData[activeTab]}</p>
        </div>
      </div>
      </div>
    </div>
    <div className="hill-core-section">
      {/* HEADING */}
      <div className="hill-core-header">
        <h2 className="hill-core-title">Our Core Values</h2>
        <p className="hill-core-subtitle">
          The principles that guide everything we do
        </p>
      </div>

      {/* CARDS */}
      <div className="hill-core-cards">
        
        {/* CARD 1 */}
        <div className="hill-core-card">
          <h3 className="hill-core-name">Henry Ford</h3>
          <p className="hill-core-quote">
            "Coming together is a beginning, staying together is progress, and working together is success."
          </p>
        </div>

        {/* CARD 2 */}
        <div className="hill-core-card">
          <h3 className="hill-core-name">Albert Einstein</h3>
          <p className="hill-core-quote">
            "Once you stop learning, you start dying."
          </p>
        </div>

        {/* CARD 3 */}
        <div className="hill-core-card">
          <h3 className="hill-core-name">Steve Jobs</h3>
          <p className="hill-core-quote">
            "Innovation distinguishes between a leader and a follower."
          </p>
        </div>

        {/* CARD 4 */}
        <div className="hill-core-card">
          <h3 className="hill-core-name">Mother Teresa</h3>
          <p className="hill-core-quote">
            "Not all of us can do great things. But we can do small things with great love."
          </p>
        </div>

      </div>
    </div>
    <Footernav/>
    </main>
  );
}

export default AboutUs;